import ServiceDetailLayout from '../components/ServiceDetailLayout';
import { serviceDetails } from '@/mocks/service-details';

export default function UpvcWindowsPage() {
  return <ServiceDetailLayout data={serviceDetails['upvc-windows']} />;
}